import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3708100b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "info-bar-wrapper" }
const _hoisted_2 = { class: "info-bar" }
const _hoisted_3 = { class: "red-txt" }
const _hoisted_4 = { class: "btn-group" }
const _hoisted_5 = { style: {"color":"var(--cm-color-text-regular)","margin-left":"5px"} }

import { ref, reactive, onMounted, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { ElMessage, ElMessageBox } from 'element-plus'

import PageSubscribeBar from '@/views/dashboard/_components/subscribe-bar/page-subscribe-bar.vue'
import Card from '@/views/dashboard/_components/card/card.vue'
import { PermissionFe, ServicePermissionService } from '@/services/service-permission.service'
import { TerminalDiscoveryService, ScanModel, TabName } from './terminal-discovery.service'
import { TerminalDiscoveryHeaderService } from './_components/terminal-discovery-header/terminal-discovery-header.service'
import { DiscoveredListService } from './_components/discovered-list/discovered-list.service'
import { IgnoredListService } from './_components/ignored-list/ignored-list.service'
import StatisticsCards from './_components/statistics-cards.vue'
import SystemDistributionChart from './_components/system-distribution-chart.vue'
import SubnetInstalledUninstalledChart from './_components/subnet-installed-uninstalled-chart.vue'
import type { SubnetStatusItem } from './_components/subnet-status/subnet-status.service'
import DiscoveredList from './_components/discovered-list/discovered-list.vue'
import SubnetStatus from './_components/subnet-status/subnet-status.vue'
import IgnoredList from './_components/ignored-list/ignored-list.vue'
import ScanScheduleSettings from './_components/scan-schedule-settings/scan-schedule-settings.vue'
import ErrorSubnetDialog from './_components/ErrorSubnetDialog.vue'
import { TableViewMode } from '@/views/dashboard/_enum/table-view-mode'
import { getListShow } from '@/utils/tool'
import CmSvgIcon from '@/components/cm-svg-icon/cm-svg-icon.vue'

// 注入服务
const hasPermission = true //servicePermissionService.getHasPermission(PermissionFe.client_find)

// 统计数据

export default /*#__PURE__*/_defineComponent({
  __name: 'terminal-discovery',
  setup(__props) {

const { t } = useI18n()
const injector = useReflectiveInjector([
  TerminalDiscoveryService,
  TerminalDiscoveryHeaderService,
  DiscoveredListService,
  IgnoredListService
])
const servicePermissionService = injector.get(ServicePermissionService)
const terminalDiscoveryService = injector.get(TerminalDiscoveryService)
const headerService = injector.get(TerminalDiscoveryHeaderService)
const discoveredListService = injector.get(DiscoveredListService)
const ignoredListService = injector.get(IgnoredListService)

const statistics = reactive({
  discoveredCount: 0,
  subnetCount: 0,
  ignoredCount: 0
})

const unJoinCount = ref(0)

// 图表数据（含 system_type，与统计接口 system_distribution 一致）
const systemDistributionData = ref<Array<{ name: string; value: number; system_type?: number }>>([])
// 组件引用
const discoveredListRef = ref()
const subnetChartRef = ref<{ refreshData: () => void } | null>(null)
const subnetStatusRef = ref()
const ignoredListRef = ref()

// 定时扫描设置
const scheduleDrawerVisible = ref(false)
const errorDialogVisible = ref(false)
const failedScanList = ref<string[]>([])

// 查看全部抽屉
const discoveredDrawerVisible = ref(false)
/** 从系统分布图点击打开抽屉时携带的 system_type；0/undefined 表示不按系统类型筛选 */
const discoveredDrawerPresetSystemType = ref<number | undefined>(undefined)
const subnetDrawerVisible = ref(false)
const ignoredDrawerVisible = ref(false)

function handleSystemDistChartClick(payload: { name: string; system_type?: number; value?: number }) {
  if ((payload.value ?? 0) <= 0) return
  const st = payload.system_type
  discoveredDrawerPresetSystemType.value =
    st !== undefined && st !== null && st !== 0 ? st : undefined
  discoveredDrawerVisible.value = true
}

function handleSubnetChartSegmentClick(payload: { row: SubnetStatusItem; segment: 'installed' | 'uninstalled' }) {
  if (!hasPermission) return
  if (payload.segment === 'installed') {
    subnetStatusRef.value?.openInstalledDrawerForRow?.(payload.row)
  } else {
    subnetStatusRef.value?.openUninstalledDrawerForRow?.(payload.row)
  }
}

function viewAllDiscovered() {
  discoveredDrawerPresetSystemType.value = undefined
  discoveredDrawerVisible.value = true
}

function handleTerminalDiscoveryStatClick(key: TabName) {
  if (!hasPermission) return
  if (key === TabName.discovered) {
    if (unJoinCount.value <= 0) return
    viewAllDiscovered()
    return
  }
  if (key === TabName.subnet) {
    if (statistics.subnetCount <= 0) return
    viewAllSubnet()
    return
  }
  if (key === TabName.ignored) {
    if (statistics.ignoredCount <= 0) return
    viewAllIgnored()
  }
}

watch(discoveredDrawerVisible, (visible) => {
  if (!visible) discoveredDrawerPresetSystemType.value = undefined
})

function viewAllSubnet() {
  subnetDrawerVisible.value = true
}

function viewAllIgnored() {
  ignoredDrawerVisible.value = true
}

// 加载统计数据
async function loadStatistics() {
  if (!hasPermission) return
  try {
    const res = await terminalDiscoveryService.getClientFindStatistics()

    statistics.discoveredCount = res.discovered_clients || 0
    statistics.subnetCount = res.subnet_count || 0
    statistics.ignoredCount = res.ignored_clients || 0
    unJoinCount.value = res.un_join_count || 0

    // 如果返回了系统分布数据，也更新系统分布图表
    if (res.system_distribution && res.system_distribution.length > 0) {
      systemDistributionData.value = res.system_distribution.map(item => ({
        name: item.system_name || 'Unknown',
        value: item.count || 0,
        system_type: item.system_type
      }))
    }
  } catch (error) {
    console.error('加载统计数据失败:', error)
  }
}

// 加载系统分布数据
async function loadSystemDistribution() {
  if (!hasPermission) return

  try {
    if (systemDistributionData.value.length === 0) {
      const res = await terminalDiscoveryService.getClientFindStatistics()
      if (res.system_distribution && res.system_distribution.length > 0) {
        systemDistributionData.value = res.system_distribution.map(item => ({
          name: item.system_name || 'Unknown',
          value: item.count || 0,
          system_type: item.system_type
        }))
      }
    }
  } catch (error) {
    console.error('加载系统分布数据失败:', error)
    systemDistributionData.value = []
  }
}

// 刷新所有数据
function refreshData() {
  loadStatistics()
  loadSystemDistribution()
  subnetChartRef.value?.refreshData?.()
  discoveredListRef.value?.refreshData()
  subnetStatusRef.value?.refreshData()
  ignoredListRef.value?.refreshData()
}

// 打开定时扫描设置
function handleOpenScheduleDrawer() {
  scheduleDrawerVisible.value = true
}

// 一键扫描
function handleOneClickScan() {
  ElMessageBox.confirm(
    t('terminalDiscoveryExtra.confirmOneClickScan'),
    t('terminalDiscovery.dialogTip'),
    {
      confirmButtonText: t('common.confirm'),
      cancelButtonText: t('common.cancel')
    }
  ).then(() => {
    terminalDiscoveryService.scanSubnet({ scan_model: ScanModel.all, ids: [] }).then((res) => {
      errorDialogVisible.value = !!res?.not_online_device_subnets?.length
      failedScanList.value = res?.not_online_device_subnets || []
      ElMessage.success(t('terminalDiscoveryExtra.oneClickScanSuccess'))
      refreshData()
    }).catch(() => {
      ElMessage.error(t('terminalDiscoveryExtra.oneClickScanFailed'))
    })
  })
}

// 定时扫描设置保存
function handleScheduleSave() {
  scheduleDrawerVisible.value = false
  refreshData()
}

onMounted(() => {
  if (hasPermission) {
    refreshData()
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(StatisticsCards, {
      "discovered-count": unJoinCount.value,
      "subnet-count": statistics.subnetCount,
      "ignored-count": statistics.ignoredCount,
      "has-permission": hasPermission,
      onStatClick: handleTerminalDiscoveryStatClick
    }, null, 8, ["discovered-count", "subnet-count", "ignored-count"]),
    _createVNode(_component_el_row, {
      gutter: 16,
      class: "charts-row"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(SystemDistributionChart, {
              data: systemDistributionData.value,
              onSliceClick: handleSystemDistChartClick
            }, null, 8, ["data"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(SubnetInstalledUninstalledChart, {
              ref_key: "subnetChartRef",
              ref: subnetChartRef,
              "has-permission": hasPermission,
              onSegmentClick: handleSubnetChartSegmentClick
            }, null, 512)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(CmSvgIcon, {
          class: "info-tips cm-ui-mr10",
          name: "assets/icons/summary-stat",
          size: 22,
          color: "var(--el-color-primary)"
        }),
        _createVNode(_component_i18n_t, {
          keypath: "terminalDiscovery.uninstalledTip",
          tag: "span"
        }, {
          count: _withCtx(() => [
            _createElementVNode("span", _hoisted_3, _toDisplayString(unJoinCount.value), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_button, {
          type: "primary",
          size: "small",
          onClick: handleOpenScheduleDrawer,
          disabled: !hasPermission
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('terminalDiscovery.scheduleScan')), 1)
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          type: "primary",
          size: "small",
          onClick: handleOneClickScan,
          disabled: !hasPermission
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('terminalDiscovery.oneClickScan')), 1)
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ]),
    _createVNode(Card, {
      size: "second",
      title: _ctx.$t('terminalDiscovery.discoveredTop10')
    }, {
      titleAfter: _withCtx(() => [
        _createVNode(_component_el_tag, { size: "small" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.listPreviewRecent10')), 1)
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(DiscoveredList, {
          ref_key: "discoveredListRef",
          ref: discoveredListRef,
          "has-permission": hasPermission,
          onViewAll: viewAllDiscovered
        }, null, 512)
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(Card, {
      size: "second",
      title: _ctx.$t('terminalDiscovery.subnetStatus'),
      class: "cm-ui-mb16 cm-ui-mt16"
    }, {
      headerRight: _withCtx(() => [
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('terminalDiscovery.subnetOfflineTip')), 1)
      ]),
      default: _withCtx(() => [
        _createVNode(SubnetStatus, {
          ref_key: "subnetStatusRef",
          ref: subnetStatusRef,
          "has-permission": hasPermission,
          onViewAll: viewAllSubnet
        }, null, 512)
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(Card, {
      size: "second",
      title: _ctx.$t('terminalDiscovery.ignoredList')
    }, {
      default: _withCtx(() => [
        _createVNode(IgnoredList, {
          ref_key: "ignoredListRef",
          ref: ignoredListRef,
          "has-permission": hasPermission,
          onViewAll: viewAllIgnored
        }, null, 512)
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(_component_el_drawer, {
      size: "80%",
      title: _ctx.$t('terminalDiscovery.allDiscovered'),
      modelValue: discoveredDrawerVisible.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((discoveredDrawerVisible).value = $event)),
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        _createVNode(DiscoveredList, {
          viewMode: _unref(TableViewMode).full,
          "has-permission": hasPermission,
          "preset-system-type": discoveredDrawerPresetSystemType.value
        }, null, 8, ["viewMode", "preset-system-type"])
      ]),
      _: 1
    }, 8, ["title", "modelValue"]),
    _createVNode(_component_el_drawer, {
      size: "80%",
      title: _ctx.$t('terminalDiscovery.allSubnetStatus'),
      modelValue: subnetDrawerVisible.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((subnetDrawerVisible).value = $event)),
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        _createVNode(SubnetStatus, {
          viewMode: _unref(TableViewMode).full,
          "has-permission": hasPermission
        }, null, 8, ["viewMode"])
      ]),
      _: 1
    }, 8, ["title", "modelValue"]),
    _createVNode(_component_el_drawer, {
      size: "80%",
      title: _ctx.$t('terminalDiscovery.allIgnored'),
      modelValue: ignoredDrawerVisible.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((ignoredDrawerVisible).value = $event)),
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        _createVNode(IgnoredList, {
          viewMode: _unref(TableViewMode).full,
          "has-permission": hasPermission
        }, null, 8, ["viewMode"])
      ]),
      _: 1
    }, 8, ["title", "modelValue"]),
    _createVNode(ScanScheduleSettings, {
      modelValue: scheduleDrawerVisible.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((scheduleDrawerVisible).value = $event)),
      onSave: handleScheduleSave
    }, null, 8, ["modelValue"]),
    _createVNode(ErrorSubnetDialog, {
      modelValue: errorDialogVisible.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((errorDialogVisible).value = $event)),
      "failed-scan-list": failedScanList.value
    }, null, 8, ["modelValue", "failed-scan-list"])
  ], 64))
}
}

})